@if (horizontalMenu) {
  <div class="navbar-header d-xl-block d-none">
    <!-- Navbar brand -->
    <ul class="nav navbar-nav flex-row">
      <li class="nav-item">
        <a class="navbar-brand" [routerLink]="['/']">
          <span class="brand-logo">
            <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="36" />
          </span>
          <h2 class="brand-text mb-0">{{ coreConfig.app.appCode }}</h2>
        </a>
      </li>
    </ul>
    <!--/ Navbar brand -->
  </div>
}

<div class="navbar-container d-flex content">
  <div class="bookmark-wrapper d-flex align-items-center">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    @if (!coreConfig.layout.menu.hidden) {
      <ul class="nav navbar-nav d-xl-none">
        <li class="nav-item">
          <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
            <span [data-feather]="'menu'" [class]="'ficon'"></span>
          </a>
        </li>
      </ul>
    }
    <!--/ Menu Toggler -->

    <!-- <span class="font-weight-bolder">SIDC Portal</span> -->
  </div>

  <ul class="nav navbar-nav align-items-center ml-auto">
    <!-- ? Language selection | Uncomment if needed-->
    <!-- <li ngbDropdown class="nav-item dropdown dropdown-language">
    <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
      <i class="flag-icon flag-icon-{{ languageOptions[_translateService.currentLang].flag }}"></i
        ><span class="selected-language">{{ languageOptions[_translateService.currentLang].title }}</span></a
        >
        <div ngbDropdownMenu aria-labelledby="dropdown-flag">
          <a *ngFor="let lang of _translateService.getLangs()" ngbDropdownItem (click)="setLanguage(lang)">
            <i class="flag-icon flag-icon-{{ languageOptions[lang].flag }}"></i> {{ languageOptions[lang].title }}
          </a>
        </div>
      </li> -->
      <!--/ Language selection -->

      <!-- User Dropdown -->
      <li ngbDropdown class="nav-item dropdown-user">
        <a
          class="nav-link dropdown-toggle dropdown-user-link"
          id="dropdown-user"
          ngbDropdownToggle
          id="navbarUserDropdown"
          aria-haspopup="true"
          aria-expanded="false"
          >
          <div class="user-nav d-sm-flex d-none">
            <span class="user-name font-weight-bolder">{{currentUser?.fullName}}</span>
            @if (currentUser?.roles[0] === 'Basic') {
              <span class="user-status">Member</span>
            }
            @if (currentUser?.roles[0] === 'Admin') {
              <span class="user-status">Admin</span>
            }
          </div>
          <span class="avatar"
            ><img
            class="round"
            [src]="currentUser?.profilePicture ? currentUser?.profilePicture : '../../../../assets/images/avatars/default-avatar.png'"
            alt="avatar"
            height="40"
            width="40" /><span class="avatar-status-online"></span
          ></span>
        </a>
        
<div
  ngbDropdownMenu
  aria-labelledby="navbarUserDropdown"
  class="dropdown-menu dropdown-menu-right user-dropdown-menu"
>
  <a ngbDropdownItem (click)="resetPassword()">
    <span [data-feather]="'key'" class="mr-50"></span>
    Change Password
  </a>

  <a ngbDropdownItem (click)="logout()">
    <span [data-feather]="'power'" class="mr-50"></span>
    Logout
  </a>
</div>

        </li>
        <!--/ User Dropdown -->
      </ul>
    </div>
